export default __webpack_public_path__ + "static/media/airplane-departure.eedeabea.svg";